var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMargin02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 163,
    viewBox: "0 0 167 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dot",
    clipPath: "url(#clip0_851_15605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M119.8 82.9707C122.54 82.9707 122.54 78.7207 119.8 78.7207C117.06 78.7207 117.06 82.9707 119.8 82.9707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M116.02 73.4707C118.76 73.4707 118.76 69.2207 116.02 69.2207C113.28 69.2207 113.28 73.4707 116.02 73.4707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.7503 112.32C15.4903 112.32 15.4903 108.07 12.7503 108.07C10.0103 108.07 10.0103 112.32 12.7503 112.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50.2796 78.2793C53.0196 78.2793 53.0196 74.0293 50.2796 74.0293C47.5396 74.0293 47.5396 78.2793 50.2796 78.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.40004 89.4895C10.3603 89.4895 12.76 87.0898 12.76 84.1295C12.76 81.1693 10.3603 78.7695 7.40004 78.7695C4.43979 78.7695 2.04004 81.1693 2.04004 84.1295C2.04004 87.0898 4.43979 89.4895 7.40004 89.4895Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M119.8 12.1302C122.761 12.1302 125.16 9.7304 125.16 6.77016C125.16 3.80991 122.761 1.41016 119.8 1.41016C116.84 1.41016 114.44 3.80991 114.44 6.77016C114.44 9.7304 116.84 12.1302 119.8 12.1302Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M83.2799 3.50977L5.37988 47.6198H161.18L83.2799 3.50977Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M126.78 57.3906H146.1",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M126.78 125.631H146.1",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M131.221 57.3906V125.631",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M141.66 57.3906V125.631",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M83.2795 37.7095C89.2221 37.7095 94.0395 32.892 94.0395 26.9495C94.0395 21.0069 89.2221 16.1895 83.2795 16.1895C77.3369 16.1895 72.5195 21.0069 72.5195 26.9495C72.5195 32.892 77.3369 37.7095 83.2795 37.7095Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M20.4502 137.391H146.1",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M15.0195 149.16H151.54",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M10.0195 160.92H156.54",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M74.7096 80.8398L68.1396 87.4099H98.4196",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M91.8496 102.169L98.4196 95.6094H68.1396",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M20.4502 57.3906H39.7802",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M20.4502 125.631H39.7802",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M24.9004 57.3906V125.631",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M35.3301 57.3906V125.631",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M60.3396 57.3906H55.8896",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M75.2195 57.3906H70.7695",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M60.3398 57.3906H70.7698",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M55.8896 125.631H60.3396",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M70.7698 125.631H60.3398",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M70.7695 125.631H75.2195",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M60.3398 57.3906V85.3006",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M60.3398 97.7207V125.631",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M70.7695 71.3006V57.3906",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M70.7695 125.631V111.721",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M91.3398 57.3906H95.7798",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M110.66 57.3906H106.22",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M106.22 57.3906H95.7803",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M110.66 125.631H106.22",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M95.7798 125.631H91.3398",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M106.22 125.631H95.7803",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M95.7803 71.3006V57.3906",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M95.7803 111.721V125.631",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M106.22 125.631V97.7207",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M106.22 85.3006V57.3906",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M60.3395 97.7202C59.8095 95.7402 59.5195 93.6602 59.5195 91.5102C59.5195 89.3602 59.8095 87.2802 60.3395 85.3002C61.9295 79.4202 65.7195 74.4402 70.7695 71.3002C74.3995 69.0502 78.6895 67.7402 83.2695 67.7402C87.8495 67.7402 92.1395 69.0402 95.7695 71.3002C100.83 74.4402 104.62 79.4102 106.2 85.3002C106.73 87.2802 107.02 89.3602 107.02 91.5102C107.02 93.6602 106.73 95.7402 106.2 97.7202C104.61 103.6 100.82 108.58 95.7695 111.72C92.1395 113.97 87.8495 115.28 83.2695 115.28C78.6895 115.28 74.3995 113.98 70.7695 111.72C65.7095 108.58 61.9195 103.61 60.3395 97.7202Z",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_851_15605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166.56,
    height: 162.34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMargin02);
export default __webpack_public_path__ + "static/media/icon_margin_02.41ec51e7e8c85fe7aaf3d91114e4c634.svg";
export { ForwardRef as ReactComponent };